import React from 'react';
import './LinkBricks.css';
import futureVideo from '../../assets/video/future.mp4';

export const Future_eye = () => {
  return (
    <div>
      <section className="section">
        <h2 className="section-title">Overview</h2>
        <p className="section-text">
          In a sunny classroom, an innocent little girl is staring at the drawing board with a paintbrush in hand, contemplating the assignment given by her teacher titled "The Future". This leads us into the main content through the girl's thoughtful gaze.
        </p>

        <p className="section-text">
          <strong>The first chapter, "What is the Future?"</strong><br />
          To trace the origins of the future, we explore how humanity has understood and explored the future from multiple perspectives, including philosophy, science, culture, and sociology.
        </p>

        <p className="section-text">
          <strong>The second chapter, "What is the Future?"</strong><br />
          Returning to the present, where is our future? What will our future look like? What can we do to strive for such a future society? Thus, in the second chapter of the short film, we showcase how the scientific explorations being conducted in the laboratory reconstruct the social lifestyles and relationships of future society. Among them, Further, Unique, Transition, Universal, Revolution, and Evolution not only deconstruct "FUTURE" but also embody the values of the laboratory.
        </p>

        <p className="section-text">
          <strong>The third chapter, "Where Does the Future Come From?"</strong><br />
          Based on the responsibilities and mission of Tsinghua researchers, adhering to the spirit of integrity and self-improvement, we continuously explore and strive forward for a better future for humanity.
        </p>

        <strong>Time: 2024.3 - 2024.5</strong>
      </section>

      <section className="section">
        <h2 className="section-title">Future Eye Project Video</h2>
        <video width="100%" controls>
          <source src={futureVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </section>

      <section className="section">
        <p className="image-description">
          <strong>Storyboard:</strong> Midjourney<br />
          <strong>Video Production:</strong> Runway<br />
          <strong>Music Composition and Sound Design:</strong> Suno<br />
          <strong>Voiceover Tool:</strong> Uberduck<br />
          <strong>Visual Enhancement:</strong> ChatGPT
        </p>
      </section>
    </div>
  );
};

export default Future_eye;